import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {NotesService} from "../../../services-otc/notes.service";
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';

@Component({
    selector: 'app-remove-note',
    templateUrl: './remove-note.component.html',
    styleUrls: ['./remove-note.component.css'],
    standalone: false
})
export class RemoveNoteComponent {

  noteId = this.data.noteID;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<OrderComponent>,
              private notesService: NotesService,
              public nav: NavBarComponent,
  ) {
  }
  cancelRemovingNote(){
    this.dialogRef.close();
  }
  deleteNewOrderNote(){
    this.nav.toggleLoading(true);
    this.notesService.deleteNoteListItem(this.data.noteID).subscribe(() => {
      this.dialogRef.close();
      this.nav.toggleLoading(false);
    });
  }
}
